<template>
    <div class="h100b" style="position: relative;">
        <iframe
            @load="loadIframePage()"
            :src="src"
            width="100%"
            height="100%"
            frameborder="0"
            scrolling="no"
        ></iframe>
        <div
            class="h100b mask mask_msg"
            id="pwdMessageBox_mask"
            style="top:0;left:0;z-index:601;zoom:1;"
        ></div>
    </div>
</template>

<script>

    export default {
        name: "index",
        props: {
            cover: {
                type: Boolean,
                default: false
            },
            src: {
                type: String,
                default: "http://baidu.com"
            }
        },
        computed: {},
        methods: {
            loadIframePage() {
            }
        },
        mounted() {
        },
        watch: {},
        components: {}
    };
</script>

<style scoped>
    .mask {
        z-index: 999;
        position: absolute;
        background-color: #000;
        filter: alpha(opacity=15);
        -moz-opacity: 0.15;
        opacity: 0.15;
    }
</style>



// WEBPACK FOOTER //
// goingsrc/vueCom/layoutVue/go-iframe.vue